const DynaCore_Table = {
    ttl: 1000 * 60 * 5,
    rowClass: 'marked',
    rowClassLast: 'marked-last',
    storageKey: 'marked-items',

    init: function () {
        "use strict";
        this.removeExpiredItems();
        this.markItems(null);

        const events = 'miniform.file.download.success '
            + 'modal.miniform.item.add.success '
            + 'modal.miniform.item.edit.success '
            + 'modal.miniform.item.edit.cancel';

        $(document)
            .off(events)
            .on(events, function (e, data) {
                e.preventDefault();
                if (typeof data !== 'undefined'
                    && true === data.hasOwnProperty('uuid')
                    && data.uuid.length
                ) {
                    DynaCore_Table.markItems(data.uuid);
                    return;
                }
                DynaCore_Table.markItems(null);
            });
    },

    /**
     * @param {?string} uuid
     */
    markItems: function (uuid) {
        "use strict";
        let items = this.getStorageItems();
        let row = $('.miniform-item-new');
        if (row.length) {
            let uuid = row.data('item-uuid');
            if (uuid.length) {
                items.push({
                    expire: Date.now() + DynaCore_Table.ttl,
                    uuid: uuid
                });
            }
        }

        if (null !== uuid && '' !== uuid) {
            let itemToRemove = null;
            $.each(items, function (i, item) {
                if (item.uuid === uuid) {
                    itemToRemove = i;
                    return false;
                }
            });
            if (null !== itemToRemove) {
                items.splice(itemToRemove, 1);
            }

            items.push({
                expire: Date.now() + DynaCore_Table.ttl,
                uuid: uuid
            });
        }

        this.setStorageItems(items);

        let lastIndex = items.length - 1;
        let expire = 0;
        $.each(items, function (i, item) {
            if (item.expire > expire) {
                expire = item.expire;
                lastIndex = i;
            }
        });

        $.each(items, function (i, item) {
            const row = $('[data-item-uuid="' + item.uuid + '"]');
            if (row.length) {
                row.removeClass(DynaCore_Table.rowClass);
                row.removeClass(DynaCore_Table.rowClassLast);
                if (lastIndex === i) {
                    row.addClass(DynaCore_Table.rowClassLast);
                } else {
                    row.addClass(DynaCore_Table.rowClass);
                }
            }
        });
    },

    /**
     * Remove expired items from local storage
     */
    removeExpiredItems: function () {
        "use strict";
        let items = this.getStorageItems();
        items = items.filter(function (item) {
            return item.expire >= Date.now();
        });

        DynaCore_Table.setStorageItems(items);
    },

    /**
     * Load items from local storage
     * @returns {Object[]}
     */
    getStorageItems: function () {
        "use strict";
        let data = localStorage.getItem(
            DynaCore_Table.storageKey
        );

        if (null === data) {
            data = {items: []};
        } else {
            data = JSON.parse(data);
        }

        if (false === data.hasOwnProperty('items')) {
            return [];
        }

        return data.items;
    },

    /**
     * Save items to local storage
     * @param {Object[]} items
     * @param {string} items[].expire
     * @param {string} items[].uuid
     */
    setStorageItems: function (items) {
        "use strict";
        const data = {
            items: items
        };

        localStorage.setItem(
            DynaCore_Table.storageKey,
            JSON.stringify(data)
        );
    },
};

$(document)
    .ready(function () {
        DynaCore_Table.init();
    });
